"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var types = {
  array: {
    editor: "ArrayEditor"
  },
  boolean: {
    editor: 'BooleanEditor'
  },
  collection: {
    editor: "CollectionEditor"
  },
  data: {
    editor: "DataGridEditor"
  },
  file: {
    editor: "FileEditor"
  },
  md: {
    editor: 'MarkdownEditor'
  },
  object: {
    editor: "ObjectEditor",
    label: false
  },
  select: {
    editor: "SelectEditor"
  },
  string: {
    editor: 'StringEditor'
  },
  slate: {
    editor: 'SlateEditor'
  }
};
exports.default = types;